import { useHasAlfredScope } from "@@/authentication/me/me-context";
import { useNavigateTo } from "./text/navigate-to";
import { useKeyboardShortcut } from "./use-keyboard-shortcut";

const useKeyboardNavShortcut = (params: {
    keys: string[];
    url: string;
    hrefTarget?: string;
    target?: HTMLDivElement;
    disabled?: boolean;
    modifiers?: {
        ctrl?: boolean;
        alt?: boolean;
        shift?: boolean;
        meta?: boolean;
    };
}): void => {
    const hasAlfredScope = useHasAlfredScope();
    const navigate = useNavigateTo();
    useKeyboardShortcut({
        keys: params.keys,
        callback: () => {
            if (!hasAlfredScope) return;
            if (params.hrefTarget) {
                window.open(params.url, params.hrefTarget);
                return;
            } else {
                navigate(params.url);
            }
        },
        modifiers: params.modifiers,
        target: params.target,
        disabled: params.disabled,
    });
    return;
};

export { useKeyboardNavShortcut };
